import { render, staticRenderFns } from "./reachRate.vue?vue&type=template&id=81aa1482"
import script from "./reachRate.vue?vue&type=script&lang=js"
export * from "./reachRate.vue?vue&type=script&lang=js"
import style0 from "./reachRate.vue?vue&type=style&index=0&id=81aa1482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports